import React, { useEffect, useState } from 'react';
import { DocListShowMoreBtn } from './DocListShowMoreBtn';
import { useItemsToRender } from './RelatedDocList.hooks';
import { RelatedDocItem } from '../RelatedDocItem';
import { RelatedDocumentItem, RelatedItemTag } from '@layouts/Related/Related.types';

interface RelatedDocListProps {
  items: RelatedDocumentItem[];
  filterTag: RelatedItemTag;
  selectedTag: boolean;
  updateSelectedTag: (val: boolean) => void;
  i18n: Record<string, string>;
  renderCustomContent: string;
}

// Id used for showing all items
const SHOW_ALL_ID = 0;

export const RelatedDocList = ({
  items = [],
  filterTag,
  selectedTag,
  updateSelectedTag,
  i18n,
  renderCustomContent,
}: RelatedDocListProps) => {
  const [filteredList, setFilteredList] = useState(items);
  const itemsToRender = useItemsToRender({
    renderItem: (item: RelatedDocumentItem) => <RelatedDocItem item={item} />,
    filteredList,
  });

  useEffect(() => {
    setFilteredList(getFilteredList(filterTag));
  }, [filterTag]);

  const getFilteredList = (filterTag: RelatedItemTag) => {
    if (filterTag === null || filterTag.id == SHOW_ALL_ID) {
      return items;
    }

    return items.filter((item) => {
      if (!item.Tags) return false;

      const tagItems = Array.isArray(item.Tags) ? item.Tags : [item.Tags];

      const itemTags = tagItems.map(({ id }) => id);
      if (filterTag.id == 'Other') {
        return itemTags?.includes(null);
      }
      return itemTags?.includes(filterTag.id);
    });
  };

  return (
    <>
      {itemsToRender}
      {filterTag.id == '001' && (
        <div dangerouslySetInnerHTML={{ __html: renderCustomContent }}></div>
      )}
      <DocListShowMoreBtn
        selectedTag={selectedTag}
        updateSelectedTag={updateSelectedTag}
        text={i18n.ShowMore || 'Show more'}
        listLength={filteredList.length}
      />
    </>
  );
};
